/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Section from 'solis/claude/primitive/section';
import ControlMoment from 'solis/claude/element/zone/control/moment';
import ControlSplit from 'solis/claude/element/zone/control/split';

import ControlHeader from 'solis/claude/section/zone/control.header';
import ControlRow from 'solis/claude/section/zone/control.row';


const getUsers = ({ zoneTimeline, currentDate, previousDate }) =>
{
  return zoneTimeline.getActiveUsers(previousDate ?? currentDate);
};


const ControlRows = (props) =>
{
  return getUsers(props).map(user =>
  (
    <ControlRow key = {user} {...props} user = {user} />
  ));
};


export default (props) =>
(
  <Section>

    <ControlHeader {...props} />
    <ControlSplit {...props} />
    <ControlRows {...props} />
    <ControlMoment {...props} />

  </Section>
);
